export enum ApplicationLinkType {
	AOC = 0,
	EXTERNAL = 1
}

export const APPLICATION_TYPES = [
	ApplicationLinkType.AOC,
	ApplicationLinkType.EXTERNAL
]
